import store from '@/store/index'
import useConfig from '@/mixins/use-api-config'
import ActionStatus from '@/mixins/use-action-status'

const { config } = useConfig()
const { status } = ActionStatus()

export const CreateWhiteLabelForCompany = async ({ paginationParams, payload }) => {
  const data = { payload, config }

  return store.dispatch('whiteLabelForCompany/CreateWhiteLabelForCompany', data)
    .then(response => {
      if ([0, '0', '00'].includes(response?.responseCode)) {
        // refresh table
        Promise.all([
          GetAllWhiteLabelCompanies(paginationParams)
        ])
        // --------------------------------
        status('success', response.responseMessage)
        return response
      } else {
        status('error', response.responseMessage)
        return response
      }
    })
    .catch((error) => {
      const errorMessagesObj = error?.response.data?.errors
      const serverErrorMessage = error.message

      const errorMessages_ = []

      for (const key in errorMessagesObj) {
        if (Object.prototype.hasOwnProperty.call(errorMessagesObj, key)) {
          const errorMessagesObjValue = errorMessagesObj[key]

          errorMessages_.push(errorMessagesObjValue[0])
        }
      }

      // update response message
      status('error', errorMessages_.length ? errorMessages_.join('* ') : serverErrorMessage)

      return error
    })
}
export const ApproveWhiteLabelCompany = async ({ whiteLabelForCompanyId, paginationParams }) => {
  const data = { whiteLabelForCompanyId, config }

  return store.dispatch('whiteLabelForCompany/ApproveWhiteLabelCompany', data)
    .then(response => {
      if ([0, '0', '00'].includes(response?.responseCode)) {
        // refresh table
        Promise.all([
          GetAllWhiteLabelCompanies(paginationParams)
        ])
        // --------------------------------
        status('success', response.responseMessage)
        return response
      } else {
        status('error', response.responseMessage)
        return response
      }
    })
    .catch((error) => {
      const errorMessagesObj = error?.response.data?.errors
      const serverErrorMessage = error.message

      const errorMessages_ = []

      for (const key in errorMessagesObj) {
        if (Object.prototype.hasOwnProperty.call(errorMessagesObj, key)) {
          const errorMessagesObjValue = errorMessagesObj[key]

          errorMessages_.push(errorMessagesObjValue[0])
        }
      }

      // update response message
      status('error', errorMessages_.length ? errorMessages_.join('* ') : serverErrorMessage)

      return error
    })
}
export const DisapproveWhiteLabelCompany = async ({ whiteLabelForCompanyId, comment, paginationParams }) => {
  const data = { whiteLabelForCompanyId, comment, config }

  return store.dispatch('whiteLabelForCompany/DisapproveWhiteLabelCompany', data)
    .then(response => {
      if ([0, '0', '00'].includes(response?.responseCode)) {
        // refresh table
        Promise.all([
          GetAllWhiteLabelCompanies(paginationParams)
        ])
        // --------------------------------
        status('success', response.responseMessage)
        return response
      } else {
        status('error', response.responseMessage)
        return response
      }
    })
    .catch((error) => {
      const errorMessagesObj = error?.response.data?.errors
      const serverErrorMessage = error.message

      const errorMessages_ = []

      for (const key in errorMessagesObj) {
        if (Object.prototype.hasOwnProperty.call(errorMessagesObj, key)) {
          const errorMessagesObjValue = errorMessagesObj[key]

          errorMessages_.push(errorMessagesObjValue[0])
        }
      }

      // update response message
      status('error', errorMessages_.length ? errorMessages_.join('* ') : serverErrorMessage)

      return error
    })
}

export const GetAllWhiteLabelCompanies = async paginationParams => {
  const data = { paginationParams, config }

  return await store.dispatch('whiteLabelForCompany/GetAllWhiteLabelCompanies', data)
    .then(response => {
      // clear no connection error
      store.commit('HAS_CONNECTION_ERROR', false)
      // ---------------------------------------------

      if ([0, '0', '00'].includes(response?.responseCode)) {
        // check response data
        if (response.data) {
          store.commit('whiteLabelForCompany/ALL_WHITE_LABEL_COMPANIES', {
            totalRecords: response?.totalRecords,
            data: response?.data
          })
        }
      }

      return response
    })
    .catch(error => error)
}
